import { useEffect, useState, lazy, Suspense } from 'react';
import { AuthProvider, useAuth } from './auth';
import { Landing } from './pages/Landing';
import { Studio } from './pages/Studio';

const Ops = lazy(() => import('./pages/Ops').then(m => ({ default: m.Ops })));

type Route = '/' | '/studio' | '/ops';

function resolveRoute(): Route {
  const p = window.location.pathname;
  if (p === '/studio') return '/studio';
  if (p === '/ops') return '/ops';
  return '/';
}

function Router() {
  const { user, loading, loginWithCode } = useAuth();
  const [route, setRoute] = useState<Route>(resolveRoute);

  // Handle Add-on code exchange on mount
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    if (code && route === '/studio') {
      loginWithCode(code).catch((err) => {
        console.error('Code exchange failed:', err);
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Listen for popstate
  useEffect(() => {
    const handlePop = () => setRoute(resolveRoute());
    window.addEventListener('popstate', handlePop);
    return () => window.removeEventListener('popstate', handlePop);
  }, []);

  if (loading) {
    return (
      <div
        style={{
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#0D0D0D',
          color: '#A0A0A0',
          fontFamily: 'Inter, sans-serif',
        }}
      >
        <div className="landing__spinner" style={{ marginRight: 8 }} />
        Carregando FLUX...
      </div>
    );
  }

  // /studio and /ops require auth
  if ((route === '/studio' || route === '/ops') && !user) {
    return <Landing />;
  }

  if (route === '/ops') {
    return (
      <Suspense fallback={
        <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0a0a0f', color: '#888', fontFamily: 'Inter, sans-serif' }}>
          <div className="landing__spinner" style={{ marginRight: 8 }} />
          Carregando Ops...
        </div>
      }>
        <Ops />
      </Suspense>
    );
  }

  return route === '/studio' ? <Studio /> : <Landing />;
}

export function App() {
  return (
    <AuthProvider>
      <Router />
    </AuthProvider>
  );
}
